export const EthnicityValue = {
  HISPANIC: 'Hispanic or Latino',
  NOT_HISPANIC: 'Not Hispanic or Latino',
} as const;
